import { api, unwrap } from "./httpClient";
import type {
  ChangePasswordPayload,
  UpdateTradingIndicatorsPayload,
  UpdatePreferencesPayload,
  UpdateProfilePayload,
  User,
} from "../types/api";

export const getProfile = () =>
  unwrap<User>(api({ method: "GET", url: "/profile" }));

export const updateProfile = (payload: UpdateProfilePayload) =>
  unwrap<User>(api({ method: "PATCH", url: "/profile", data: payload }));

export const updatePreferences = (payload: UpdatePreferencesPayload) =>
  unwrap<User>(
    api({ method: "PATCH", url: "/profile/preferences", data: payload })
  );

export const updateTradingIndicators = (
  payload: UpdateTradingIndicatorsPayload
) =>
  unwrap<User>(
    api({ method: "PATCH", url: "/profile/trading-indicators", data: payload })
  );

export const changePassword = (payload: ChangePasswordPayload) =>
  unwrap<{ ok: boolean }>(
    api({ method: "PATCH", url: "/profile/password", data: payload })
  );
